import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Download } from "lucide-react";
import api, { zar, downloadPdf } from "@/lib/api";
import { PageHeader, useFetch, Spinner } from "@/components/portal/ui";
import { StatusBadge } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";

const QSTYLE = { Accepted: "Delivered", Sent: "In Transit", Draft: "Pending Pickup", Expired: "Exception" };
function fmt(t) { return t ? new Date(t).toLocaleDateString("en-ZA", { dateStyle: "medium" }) : "—"; }

export default function Quotes() {
  const { data, loading } = useFetch(() => api.get("/portal/quotes").then((r) => r.data));
  if (loading) return <Spinner />;
  return (
    <div>
      <PageHeader title="Quotations" subtitle="Freight estimates and accepted quotes">
        <Link to="/quote"><Button className="bg-primary hover:bg-red-700" data-testid="new-quote-btn">New Quote</Button></Link>
      </PageHeader>
      <div className="rounded-xl border border-border bg-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-muted/50 text-left text-xs uppercase tracking-wide text-muted-foreground">
            <tr><th className="p-4">Quote #</th><th className="p-4">Route</th><th className="p-4 hidden md:table-cell">Service</th><th className="p-4">Total</th><th className="p-4">Status</th><th className="p-4 hidden lg:table-cell">Created</th><th className="p-4"></th></tr>
          </thead>
          <tbody className="divide-y divide-border">
            {data.quotes.map((q) => (
              <tr key={q.id} data-testid={`quote-${q.quote_number}`} className="hover:bg-muted/40">
                <td className="p-4 font-mono font-semibold">{q.quote_number}</td>
                <td className="p-4">{q.origin_city} → {q.dest_city}</td>
                <td className="p-4 hidden md:table-cell text-muted-foreground">{q.service_type}</td>
                <td className="p-4 font-semibold">{zar(q.total_zar)}</td>
                <td className="p-4"><StatusBadge status={QSTYLE[q.status] || q.status} /></td>
                <td className="p-4 hidden lg:table-cell text-muted-foreground">{fmt(q.created_at)}</td>
                <td className="p-4"><Button variant="ghost" size="sm" data-testid={`quote-dl-${q.quote_number}`} onClick={async () => { try { await downloadPdf(`/portal/quotes/${q.id}/pdf`, `${q.quote_number}.pdf`); toast.success("Quote downloaded"); } catch { toast.error("Download failed"); } }}><Download size={16} /></Button></td>
              </tr>
            ))}
            {data.quotes.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-muted-foreground">No quotations yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
